import request from '@/http/request'

export function login(data) {
    
    return request({
        url: '/login',
        method: 'post',
        data:data
    })
}




// WEBPACK FOOTER //
// ./src/api/user/login.js